// extracted by css-extract-rspack-plugin
export default {"screen":"screen-Zh62eG"};